import axios from "axios";
import { API_V2 } from "@Models/GWDomain";

const baseUrlApiGw = `${API_V2}/auth`;

export const getToken_service = async (params) => {
  const headers = {
    "Content-Type": "application/x-www-form-urlencoded",
  };
  try {
    const results = await axios.post(`${baseUrlApiGw}/connect/token`, params, {
      headers,
    });
    return {
      isSuccess: true,
      status: results.status || 200,
      message: "Inicio de sesión exitoso",
      data: results.data,
    };
  } catch (error) {
    return {
      isSuccess: false,
      status: error?.response?.status || 500,
      data: null,
      message:
        error?.response?.data?.message ||
        "Lo sentimos ha ocurrido un error inesperado",
    };
  }
};
